/**
 * Cabo's per-game lobby options: starting hand size.
 */

import type { LobbyOptionsProps } from "../registry.js";
import { Select } from "../../components/Select.js";

export function CaboLobbyOptions({ lobby, isHost, send }: LobbyOptionsProps) {
  const startingCards =
    typeof lobby.config.startingCards === "number" ? lobby.config.startingCards : 4;
  function setStartingCards(n: number) {
    send({ t: "set_config", config: { startingCards: n } });
  }
  return (
    <div className="lobby-game-options">
      <div className="muted lobby-game-options-title">Cabo options</div>
      <label
        className="row inline-control"
        style={{ gap: 8, cursor: isHost ? "pointer" : "default" }}
        title="More cards = harder memory test."
      >
        <span>Starting cards per player</span>
        <Select<number>
          value={startingCards}
          onChange={setStartingCards}
          disabled={!isHost}
          options={[4, 6, 8].map((n) => ({ value: n, label: String(n) }))}
          width={80}
          compact
        />
      </label>
      {!isHost && (
        <div className="muted" style={{ fontSize: 12 }}>
          Game options are set by the host.
        </div>
      )}
    </div>
  );
}
